module.exports = __webpack_public_path__ + "img/main3.86fd9533.jpg";